import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "options" }

import PassCard from "@/components/RegistrationPage/Card/PcVersion/PassCard.vue";
import WhitePassCard from "@/components/RegistrationPage/Card/PcVersion/white_pass/WhitePassCard.vue";

import { defineComponent } from 'vue'
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";
import store from "@/store";

const __default__ = defineComponent({
    name: 'SubscriptionsHolder',

    data(): {
        order: string[]
    } {
        return {
            order: [
                'STAR_SHINE',
                'AURORA',
                'ANGULAR_MOMENTUM',

                'WHITE_PASS',

                'CMB_RADIATION',
                'DARK_MATTER',
                'BLACK_PASS',
            ]
        }
    },

    computed: {
        passes(): PassProperties[]
        {
            return store.state.passes.sort((a: PassProperties, b: PassProperties): number => this.order.indexOf(a.code) - this.order.indexOf(b.code))
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passes, (pass, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (pass.code === 'WHITE_PASS')
          ? (_openBlock(), _createBlock(WhitePassCard, {
              key: 0,
              pass: pass
            }, null, 8, ["pass"]))
          : (_openBlock(), _createBlock(PassCard, {
              key: 1,
              pass: pass
            }, null, 8, ["pass"]))
      ], 64))
    }), 128))
  ]))
}
}

})